import React, { useEffect, useState } from 'react';
import {
  List,
  Datagrid,
  TextField,
  EditButton,
  Pagination,
  useGetIdentity,
  useGetList,
  FilterList,
  Loading,
  FilterListItem,
  useListContext,
  FunctionField,
} from 'react-admin';
import { Box, Card, CardContent, Chip, FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import CategoryIcon from '@mui/icons-material/LocalOffer';
import ToggleRowStyle from './Common';
import { supabaseClient } from './supabase';

const ResourceFilterSideBar = (props) => {
    const { data, isLoading, error, } = useGetList('resource_types', {
        pagination: { page: 1, perPage: 20 },
        sort: { field: 'name', order: 'ASC' },
    });
    if (isLoading) return <Loading />;
    if (error) return '<p>Error</p>';

    return (
        <Card sx={{ order: -1, mr: 2, mt: 8, width: 380 }}>
            <CardContent>
            <FilterList label="Resource sections" icon={<CategoryIcon />}>
                {data.map((record) => {
                return (
                    (
                    <FilterListItem
                        sx={{ borderLeft: `10px solid ${record.color}`, margin: 1 }}
                        label={record.name}
                        value={{ resource_type_id: record.id }}
                        key={record.id}
                    />
                    )
                );
                })}
            </FilterList>
            </CardContent>
        </Card>
    );
}

const TagFilter = () => {
    const { filterValues, setFilters, displayedFilters } = useListContext();
    const [availableTags, setAvailableTags] = useState([]);

    useEffect(() => {
        const resourceTypeId = filterValues.resource_type_id;
        if (resourceTypeId) {
            supabaseClient
                .from('resources')
                .select('tags')
                .eq('resource_type_id', resourceTypeId)
                .then(({ data }) => {
                    if (data) {
                        const tags = [...new Set(data.flatMap(r => r.tags || []).filter(Boolean))].sort();
                        setAvailableTags(tags);
                    }
                });
        } else {
            setAvailableTags([]);
            if (filterValues.tag) {
                const newFilters = { ...filterValues };
                delete newFilters.tag;
                setFilters(newFilters, displayedFilters);
            }
        }
    }, [filterValues.resource_type_id]); // eslint-disable-line react-hooks/exhaustive-deps

    if (!availableTags.length) return null;

    const handleChange = (e) => {
        const newFilters = { ...filterValues };
        if (e.target.value) {
            newFilters.tag = e.target.value;
        } else {
            delete newFilters.tag;
        }
        setFilters(newFilters, displayedFilters);
    };

    return (
        <Box sx={{ px: 1, pb: 1 }}>
            <FormControl size="small" sx={{ minWidth: 220 }}>
                <InputLabel>Filter op tag</InputLabel>
                <Select
                    label="Filter op tag"
                    value={filterValues.tag || ''}
                    onChange={handleChange}
                >
                    <MenuItem value="">Alle</MenuItem>
                    {availableTags.map(tag => (
                        <MenuItem key={tag} value={tag}>{tag}</MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Box>
    );
};

const ResourceList = (props) => {
    const {
      data: identity, isLoading: isIdentityLoading, error: identityError,
    } = useGetIdentity();
    if (isIdentityLoading) return <>Loading....</>;
    if (identityError) return <>Error...</>;
    return (
      <List
        {...props}
        aside={<ResourceFilterSideBar />}
        title="List of resources"
        sx={{
          '& .RaList-actions': {
            maxWidth: '10%',
            width: '10%',
            border: '1px solid red',
          },
        }}
      >
        <TagFilter />
        <Pagination />
        <Datagrid
          rowStyle={ToggleRowStyle}
          bulkActionButtons={false}
          key={(record) => `${record.id}`}
          rowClick={'show'}
        >
            <TextField source="title" />
            <FunctionField
                label="Tags"
                render={record => (
                    <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap' }}>
                        {(record.tags || []).map(tag => (
                            <Chip key={tag} label={tag} size="small" />
                        ))}
                    </Box>
                )}
            />
            {['admin', 'teacher'].includes(identity.role) ? (
              <>
                  <EditButton />
              </>
            ) : null}
        </Datagrid>
      </List>
    );
  };

  export default ResourceList;
